import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAsync } from 'hooks/useAsync';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { getPaymentPreferences, postPaymentMethods } from 'api/services/payway';
import { PREFERRED_PAYMENT_METADATA_KEY, PREFERRED_PAYMENT_ENABLED } from '../constants';

const PREFERRED_PAYMENT_DEFAULT = 1;

// userToken opcional: lo usa el flujo de vinculación QR, donde estos servicios
// se autentican con el user_token de link-sessions/link. Sin él, las dos
// llamadas quedan exactamente como estaban.
export const usePreferredPayment = (gatewayName, { userToken } = {}) => {
  const [preferredPayment, fetchPreferredPayment] = useAsync(getPaymentPreferences);
  // useAsync solo propaga un argumento, así que el token se cierra aquí en vez
  // de viajar como segundo parámetro.
  const [paymentMethods, mutatePaymentMethods] = useAsync(paymentMethodId =>
    postPaymentMethods(paymentMethodId, { userToken }),
  );
  const config = useSelector(selectMetadataKeyByRegion(PREFERRED_PAYMENT_METADATA_KEY));

  const preferredPaymentData = preferredPayment?.data?.data?.data;
  const selectedPayment = preferredPaymentData?.find(method => method.gateway_name === gatewayName);
  const { payment_method_id: paymentMethodId } = selectedPayment || {};
  const isButtonEnabled = config.enable ?? PREFERRED_PAYMENT_ENABLED;

  const isPreferred =
    selectedPayment?.gateway_name === gatewayName &&
    selectedPayment?.is_default === PREFERRED_PAYMENT_DEFAULT;

  const isLoading = preferredPayment.loading ?? paymentMethods.loading;

  const setPaymentAsPreferred = async () => {
    await mutatePaymentMethods(paymentMethodId);
    fetchPreferredPayment({ userToken });
  };

  useEffect(() => {
    if (isButtonEnabled) fetchPreferredPayment({ userToken });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    isPreferred,
    isLoading,
    preferredPaymentError: preferredPayment.error,
    paymentMethodsError: paymentMethods.error,
    setPaymentAsPreferred,
  };
};